'use client';
import styles from './not-found.module.scss';
import clsx from 'clsx';
import { Button } from '@mantine/core';
import { useRouter } from 'next/navigation';

export default function NotFound() {
    const router = useRouter();
    return (
        <div className={clsx('not_found_page', styles.notFoundContainer)}>
            <div className={styles.notFoundContent}>
                <h1 className={styles.title}>Page Not Found</h1>
                <p className={styles.description}>Sorry, the page you are looking for does not exist.</p>
                <Button className="theme_btn dark_blue_btn" onClick={() => router.push(`/`)}>
                    Go back to Home
                </Button>
            </div>
        </div>
    );
}
